/* eslint-disable */
/* eslint-disable import/prefer-default-export */

export const MEDIA_QUERY = {
  MOBILE: '(max-width: 1024px) and (orientation : portrait)',
  DARK_THEME: 'screen and (prefers-color-scheme: dark)',
  LIGHT_THEME: 'screen and (prefers-color-scheme: light)',
}
